(ns common.schema.entities.lp-portal.lp-report-investor-commitment
  (:require [common.schema.schema-utils :as su]))

(defn- system-controlled
  [opts]
  (assoc opts :system-semantics su/system-controlled-optional-field-semantics))

(def schema
  (concat (su/text-simple-field :lp-report-investor-commitment/investor-name
                                "Name"
                                (system-controlled {:authorization su/access-system-lpg}))
          (su/text-simple-field :lp-report-investor-commitment/private-file-import-id
                                "Private file import id"
                                (system-controlled {:authorization su/access-system-lpg}))
          (su/text-edn-field :lp-report-investor-commitment/data
                             "Data"
                             (system-controlled {:authorization su/access-system-lpg}))
          (su/multi-ref-field :lp-report-investor-commitment/materials
                              "LP report commitment materials"
                              [:entity.type/attachment]
                              (system-controlled {:authorization su/access-system-lpg}))))
